import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Venue } from '@/interfaces/models/Venue';
import { mixins } from 'vue-class-component';
import Editable from '@/mixins/Editable';
import { OptionGroup } from '@/interfaces/models/OptionGroup';
import { Article } from '@/interfaces/models/Article';

const foodcard = namespace('foodcard');
const venue = namespace('venue');

@Component
export class EditArticle extends mixins(Editable) {
  @venue.State('active') public venue!: Venue;

  @foodcard.State('activeArticle') public active!: Article;
  @foodcard.State('options') public options!: OptionGroup[];

  @foodcard.Action('fetchOptions') public getOptions!: any;
  @foodcard.Action('setOptionFilter') public setOptionFilter!: any;
  @foodcard.Action('storeArticle') public store!: any;
  @foodcard.Action('updateArticle') public update!: any;
  @foodcard.Action('changeCategory') public newCategory!: any;
  @foodcard.Action('showArticle') public show!: any;

  @foodcard.Action('uploadArticleImage') public uploadImage!: any;
  @foodcard.Action('uploadArticleIcon') public uploadIcon!: any;
  @foodcard.Action('uploadArticleBanner') public uploadBanner!: any;

  get title() {
    return this.editing ? 'article.edit' : 'article.create';
  }

  get article() {
    if (this.active && this.editing) {
      return { ...this.active, category: this.$route.params.category };
    }

    return null;
  }

  public created() {
    if (!this.venue) {
      this.$startLoading('venue');
    }
  }
}
